var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staking-detail locking" },
    [
      _c("div", { staticClass: "item" }, [
        _c("div", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("tradeDividend.lockedAmount")) +
              "\n            "
          ),
          _c(
            "span",
            { staticClass: "help __pointer" },
            [
              _c("tooltips", {
                staticClass: "tips",
                attrs: { content: _vm.$t("tradeDividend.lockAmountTips") }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bold" }, [
          _vm._v(_vm._s(_vm.vxLocked || 0) + " dSLS")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item no-border" }, [
        _c("div", [_vm._v(_vm._s(_vm.$t("tradeDividend.unlockAmount")))]),
        _vm._v(" "),
        _c("div", { staticClass: "bold" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.vxUnlocking || 0) +
              " dSLS\n            "
          ),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.vxBalanceInfo.vxUnlocking,
                expression: "vxBalanceInfo.vxUnlocking"
              }
            ],
            staticClass: "down-icon __pointer",
            on: { click: _vm.showVxUnlockingDetails }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "operations" }, [
        _vm.isInitAutoLock
          ? _c(
              "div",
              { staticClass: "check", on: { click: _vm.tooggleAutoLock } },
              [
                _c("Checkbox", {
                  staticClass: "check-box",
                  attrs: { canClick: false },
                  model: {
                    value: _vm.isAutoLock,
                    callback: function($$v) {
                      _vm.isAutoLock = $$v
                    },
                    expression: "isAutoLock"
                  }
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("tradeDividend.autoLock")) +
                    "\n        "
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn add __pointer",
            on: {
              click: function($event) {
                return _vm.showVXConfirm(true)
              }
            }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeDividend.lock")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.canIUnlock,
                expression: "!canIUnlock"
              }
            ],
            staticClass: "btn unuse"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeDividend.unlock")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.canIUnlock,
                expression: "canIUnlock"
              }
            ],
            staticClass: "btn cancel __pointer",
            on: {
              click: function($event) {
                return _vm.showVXConfirm(false)
              }
            }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeDividend.unlock")) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("vx-confirm", { ref: "vxConfirm" }),
      _vm._v(" "),
      _c("vxUnlockingConfirm", { ref: "vxUnlockingDetail" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }